<template>
  <div>
    <!--Invalid Image-->
    <div v-if="invalidImage">
        <b-icon 
            icon="exclamation-triangle"
            variant="primary" 
            font-scale="7.5"
        />
        <h5 class="card-title">{{ $t("invalid-image") }}</h5>
        <p class="card-text">
            {{ $t("invalid-image-text") }}
        </p>
    </div>
    
    <!-- Image Preview -->
    <div v-if="latestImageURL && !invalidImage">
        <img 
            :src="latestImageURL" 
            :alt="$t('uploaded-image')"
            ref="imageEdit"
            width="340px"
        />
    </div>

    <div v-if="latestImageURL && !invalidImage" class="mt-2">
        <button 
            class="btn btn-secondary" 
            @click="rotateImage"
        >
            {{ $t('rotate')}}
        </button>

        <button 
            class="btn btn-secondary ml-1" 
            @click="cropImage"
        >
            {{ $t('crop') }}
        </button>

        <button 
            v-if="editedImageURL.length > 0"
            class="btn btn-secondary ml-1"
            @click="undo">{{ $t('undo') }}
        </button>

        <button 
            v-if="editedImageURL.length > 0"
            class="btn btn-secondary ml-1 mt-1"
            @click="resetImage">{{ $t('reset') }}
        </button>
    </div>

    <button 
        v-if="latestImageURL" 
        class="btn btn-primary mt-1"
        @click="doneEditing">
            {{  $t('done') }}
    </button>
</div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    props: {
        imageURL : {
            type: [String, Blob],
            default: null
        },
        aspectRatio : {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            editedImageURL: [],
            cropper: null,
        };
    },
    mounted(){
        this.initCropper();
    },
    methods: {
        initCropper() {
            const image = this.$refs.imageEdit;
            this.cropper = new Cropper(image, {
                aspectRatio: this.aspectRatio,
                viewMode: 1,
            });
        },
        rotateImage() {
            if (this.cropper) {
                this.cropper.rotate(90); 
            }
        },
        cropImage() {
            if (this.cropper) {
                const croppedCanvas = this.cropper.getCroppedCanvas();
                this.editedImageURL.push(croppedCanvas.toDataURL('image/jpeg'));
                /*
                    Rotating does a this.cropper.rotate,
                    which updates it. However, cropping does not.
                    Hence the need for updating it
                */
                this.updateCropper();
            }
        },
        updateCropper(){
            this.cropper.destroy(); 
            this.$nextTick(() => {
                this.initCropper(); 
            });
        },
        resetImage(){
            this.editedImageURL = [];
            this.updateCropper();
        },
        /*downloadImage() {
            const link = document.createElement('a');
            link.href = this.editedImageUrl;
            link.download = 'edited-image.jpg';
            link.click();
        },*/
        undo(){
            this.editedImageURL.pop();
            this.updateCropper();
        },
        doneEditing(){
            this.$emit('image-output', this.latestImageURL);
            this.cropper.destroy(); 
        }
    },
    computed: {
        latestImageURL(){
            if (this.editedImageURL.length === 0) return this.processedImageURL;
            return this.editedImageURL[this.editedImageURL.length-1];
        },
        processedImageURL() {
            if (this.imageURL instanceof Blob) return URL.createObjectURL(this.imageURL);
            return this.imageURL;
        },
        invalidImage () {
            return this.imageURL == '' || this.imageURL == null
        }
    },
    beforeDestroy() {
        if (this.cropper) {
            this.cropper.destroy();
        }
    },
};
</script>
